import { ChangeEvent, useEffect, useState } from 'react'

import { useParams } from 'react-router'
import { DefaultRootState, useDispatch, useSelector } from 'react-redux'
import { animateScroll as scroll } from 'react-scroll'
import { getMonth, format } from 'date-fns'
import ptBR from 'date-fns/locale/pt-BR'
import {
  CircularProgress,
  InputLabel,
  MenuItem,
  Select
} from '@material-ui/core'
import ArrowForwardIos from '@material-ui/icons/ArrowForwardIos'

import { goalListRequest } from 'store/modules/goal/actions'
import { IGoal, IGoalProps } from 'store/modules/goal/types'
import { guideTable } from './guideTable'

import { Container, FormControl, GoalGuide, GuideTable } from './styles'
import { NextStepButton } from '../../../style'

interface SelectorGoal {
  state: DefaultRootState
  goal: IGoalProps
}

interface MonthStepProps {
  goal: IGoal
  handleNextStep: () => void
  storeGoal: (goal: IGoal) => void
}

const MAX_MONTHS_AHEAD_FOR_GOALS = 6

const MonthStep = ({ goal, handleNextStep, storeGoal }: MonthStepProps) => {
  const [months, setMonths] = useState<string[]>([])
  const [selectedMonth, setSelectedMonth] = useState('')

  const token = localStorage.getItem('@NeoPro:token')
  const dispatch = useDispatch()
  const { storeId } = useParams<{ storeId: string }>()

  const { loading, goalList } = useSelector<SelectorGoal, IGoalProps>(
    state => state.goal
  )

  const generateMonths = () => {
    const currentMonth = getMonth(new Date())
    const currentYear = new Date().getFullYear()

    const auxMonths: string[] = []
    for (
      let i = currentMonth;
      i <= currentMonth + MAX_MONTHS_AHEAD_FOR_GOALS;
      i++
    ) {
      const date = new Date(currentYear, i, 1)
      date.setUTCHours(15, 0, 0, 0)

      const isoDate = date.toISOString()

      const isSameGoalMonth =
        date.getMonth() === new Date(goal.month).getMonth()

      const isEditing = !!goal.month
      const isEditingCurrentGoalMonth = isSameGoalMonth && isEditing

      const hasGoalThisMonth = goalList.find(goal => goal.month === isoDate)

      if (!hasGoalThisMonth || isEditingCurrentGoalMonth) {
        auxMonths.push(isoDate)
      }
    }
    return auxMonths
  }

  const handleClickNextStep = () => {
    if (!goal.month) {
      storeGoal({ ...goal, month: selectedMonth })
    } else {
      handleNextStep()
    }
  }

  useEffect(() => {
    // gera lista de meses que podem criar meta
    if (goalList) {
      setMonths(generateMonths())
    }
  }, [goalList])

  useEffect(() => {
    if (goal.month) {
      const goalMonthNotInState = months.indexOf(goal.month) < 0

      if (goalMonthNotInState) {
        const auxMonths = [...months]
        auxMonths.push(goal.month)
        setMonths(auxMonths)
      }
      setSelectedMonth(goal.month)
    }

    const hasNoGoalList = goalList.length === 0
    if (hasNoGoalList) {
      dispatch(goalListRequest(storeId, token))
    }
    scroll.scrollToTop()
  }, [goal.month, storeId, token])

  useEffect(() => {
    // gera lista de meses que podem criar meta
    if (goalList) {
      setMonths(generateMonths())
    }
  }, [goalList])

  const handleChangeMonthSelect = (
    event: ChangeEvent<{ name?: string | undefined; value: unknown }>
  ) => {
    const newSelectedMonth = event.target.value as string
    setSelectedMonth(newSelectedMonth)
  }

  const formatDate = (date: string) => {
    const formattedDate = format(new Date(date), 'MMMM - yyyy', {
      locale: ptBR
    })

    return formattedDate
  }

  const currentSelectedMonth = selectedMonth || goal?.month

  return (
    <Container>
      <h1>A meta é para qual mês?</h1>
      <FormControl variant='outlined'>
        <InputLabel id='month-select-label'>
          {loading ? (
            <CircularProgress size={20} />
          ) : currentSelectedMonth ? (
            formatDate(currentSelectedMonth)
          ) : (
            'Selecione um Mês'
          )}
        </InputLabel>

        <Select
          labelId='month-select-label'
          id='month-select'
          label='Selecione um Mês'
          value={currentSelectedMonth || ''}
          disabled={loading || !!goal.month}
          onChange={handleChangeMonthSelect}
        >
          {months.map(month => (
            <MenuItem key={month} value={month}>
              {formatDate(month)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {currentSelectedMonth && (
        <NextStepButton
          onClick={handleClickNextStep}
          style={{ marginLeft: 0 }}
          data-cy='nextStepButton'
        >
          Próxima etapa
          <ArrowForwardIos className='next-button-icon' />
        </NextStepButton>
      )}

      <GoalGuide>
        <div>
          <h2>O que iremos definir nas próximas etapas?</h2>
          <span>O preenchimento dura em média 4 minutos.</span>
        </div>

        <GuideTable>
          {guideTable.map(el => (
            <div key={el.title}>
              <h3>{el.title}</h3>
              <span>{el.listTitle}</span>
              <ul>
                {el.list.map(listEl => (
                  <li key={listEl}>{listEl}</li>
                ))}
              </ul>
            </div>
          ))}
        </GuideTable>
      </GoalGuide>

      {/*   MODAL PARA COPIAR META DE OUTRA LOJA (desativado por enquanto)  */}
      {/* {isShowModal.enable && !isShowModal.isAlert && <CopyGoalModal />} */}
    </Container>
  )
}

export default MonthStep
